import { LocationResponseDto, AssetLifecycleFunction, LocationTypeName } from '@peritasai/types';

/**
 * Location entity representing the core business object
 * This entity contains business logic and validation
 */
export class LocationEntity {
  public readonly id: string;
  public readonly name: string;
  public readonly departmentOrUnit: string;
  public readonly floor: string;
  public readonly facilityId: string;
  public readonly facilityName: string;
  public readonly locationTypeId: string | null;
  public readonly locationType: LocationTypeName | null;
  public readonly additionalDetails: string | null;
  public readonly dropoff: boolean | null;
  public readonly proximityRange: string | null;
  public readonly xCoordinate: number | null;
  public readonly yCoordinate: number | null;
  public readonly zCoordinate: number | null;
  public readonly assetLifecycleFunction: AssetLifecycleFunction | null;
  public readonly parentId: string | null;
  public readonly parentLocationName: string | null;
  public readonly children: string[];
  private readonly dto;

  constructor(dto: LocationResponseDto) {
    this.dto = dto;

    this.id = dto.id;
    this.name = dto.name;
    this.departmentOrUnit = dto.departmentOrUnit;
    this.floor = dto.floor;
    this.facilityId = dto.facility.id;
    this.facilityName = dto.facility.name;
    this.locationTypeId = dto.locationType?.id ?? null;
    this.locationType = this.normalizeLocationTypeName(dto.locationType?.name);
    this.additionalDetails = dto.additionalDetails ?? null;
    this.dropoff = dto.dropoff ?? null;
    this.proximityRange = dto.proximityRange ?? null;
    this.xCoordinate = dto.xCoordinate ?? null;
    this.yCoordinate = dto.yCoordinate ?? null;
    this.zCoordinate = dto.zCoordinate ?? null;
    this.assetLifecycleFunction = dto.assetLifecycleFunction;
    this.parentId = dto.parent?.id ?? null;
    this.parentLocationName = dto.parent?.name ?? null;
    this.children = (dto.children ?? []).map((c)=>c.id)
  }

  private normalizeLocationTypeName(
    value?: string | null
  ): LocationTypeName | null {
    if (Object.values(LocationTypeName).includes(value as LocationTypeName)) {
      return value as LocationTypeName;
    }

    return null;
  }

  /**
   * Convert back to DTO for API communication
   */
  public toDTO(): LocationResponseDto {
    return this.dto;
  }
}
